<template>
  <div style="height: 100vh">
    <div class="app-header">
      <div class="header-content">
        <div class="logo-section" @click="goToBack()">
          <i class="el-icon-back back-icon"></i>
          <img src="@/assets/img/logo.jpg" alt="logo" class="logo-img" />
          <span class="title">人事考试视频指挥调度一体化平台</span>
        </div>
        <div class="header-actions">
          <i class="el-icon-setting setting-icon" v-if="false" @click="showSetting = !showSetting" title="设置"></i>
        </div>
      </div>
    </div>

    <div class="main-content">
      <div class="sidebar">
        <div class="sidebar-scroll">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100%" class="sidebar-form"
            label-position="top" size="small">
            <el-form-item label="选择日期" prop="date">
              <el-date-picker v-model="ruleForm.date" type="datetimerange" align="right" start-placeholder="开始日期"
                end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" style="width: 100%">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="轨迹类型">
              <el-select style="width: 100%" v-model="type" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="考试列表">
              <el-select style="width: 100%" v-model="examId" placeholder="请选择考试" multiple clearable collapse-tags
                @change="changeExam">
                <el-option v-for="item in examOptions" :key="item.id" :label="item.examName" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="选择设备" class="device-tree-item">
              <div class="tree-container">
                <el-tree ref="tree" :data="devicesTreeData" show-checkbox node-key="id" :props="defaultProps"
                  highlight-current :default-expanded-keys="['1']">
                </el-tree>
              </div>
            </el-form-item>

            <div class="action-buttons">
              <el-button class="action-btn" type="primary" @click="submitForm('ruleForm')" :disabled="btnDisabled"
                icon="el-icon-map-location">试卷车轨迹查看</el-button>
              <el-button class="action-btn" type="primary" @click="openMultiVideoDialog" :disabled="btnDisabled"
                icon="el-icon-video-play">试卷车实时视频查看</el-button>
            </div>
          </el-form>

          <div class="path-legend" v-if="pathList.length > 0">
            <div class="legend-title">已加载轨迹</div>
            <div v-for="(v, i) in pathList" :key="v.account" class="legend-item">
              <span class="legend-name">{{ v.name }}</span>
              <div class="legend-color" :style="{ backgroundColor: colorList[i % colorList.length] }"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="map-area">
        <div id="mapContainer"></div>
      </div>
    </div>
    <div v-if="showSetting" style="
        position: fixed;
        top: 0;
        width: 300px;
        right: 0px;
        z-index: 9;
        background-color: rgba(255, 255, 255, 0.8);
      ">
      <div style="margin-top: 70px; padding: 10px 20px 20px 10px">
        <!-- <el-button >开始巡航</el-button>
        <el-button>暂停</el-button>
        <el-button>恢复</el-button>
        <el-button>停止</el-button>
        <el-button>销毁</el-button> -->
        <div style="font-weight: bold; font-size: 18px; margin-bottom: 16px">
          导航器设置
        </div>
        <div>
          <div>时速： {{ speedValue }} km/h</div>
          <el-slider v-model="speedValue" :step="1000" :min="1000" :max="100000" @change="changeSpeed">
          </el-slider>
        </div>
        <!-- <div>
          <el-switch v-model="loop" active-text="循环" inactive-text="不循环"></el-switch>
        </div> -->
      </div>
    </div>

    <!-- 轨迹信息弹框 -->
    <el-dialog title="试卷车轨迹视频回放查看" :visible.sync="dialogVisible" width="800px" center custom-class="trace-dialog"
      :show-close="false">
      <div class="trace-info">
        <!-- 基本信息 -->
        <div class="basic-info">
          <h3 class="section-title">基本信息</h3>
          <div class="info-row">
            <div class="info-item">
              <span class="info-label">考区：</span>
              <span class="info-value">{{ dialogData.examDistrictName }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">车辆编号：</span>
              <span class="info-value">{{ dialogData.vehicleNumber }}</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-item">
              <span class="info-label">考点名称：</span>
              <span class="info-value">{{ dialogData.examPlaceName }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">点位时间：</span>
              <span class="info-value">{{ dialogData.locationTime }}</span>
            </div>
          </div>
        </div>

        <!-- 回放视频 -->
        <div class="video-section">
          <h3 class="section-title">回放视频 <el-tag type="success" size="mini" style="margin-left:8px;vertical-align:middle;">☁ 云端录像</el-tag></h3>
          <div class="playback-search">
            <el-date-picker v-model="playbackStartTime" type="datetime" placeholder="选择开始时间"
              format="yyyy-MM-dd HH:mm:ss" value-format="yyyyMMddHHmmss" style="width: 300px"
              @change="handleStartTimeChange" popper-class="no-now-button"></el-date-picker>
            <el-button type="primary" @click="changePlaybackTime" class="query-btn">查询</el-button>
          </div>
          <div class="video-container" :class="{ 'video-enlarged': videoEnlarged }">
            <div id="ezuiPlayer" class="ezui-player"></div>
          </div>
        </div>

        <!-- 关闭按钮 -->
        <div class="dialog-actions">
          <el-button @click="dialogVisible = false" class="close-btn">关闭</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 多路视频回放弹框 -->
    <el-dialog title="试卷车实时视频查看" :visible.sync="multiVideoDialogVisible" fullscreen append-to-body
      custom-class="multi-video-dialog" @closed="handleMultiVideoClose">
      <div class="multi-video-container">
        <div v-for="(device, index) in selectedVideoDevices" :key="device.value" class="video-card">
          <div class="video-card-header">
            <div class="header-left">
              <i class="el-icon-video-camera"></i>
              <span class="device-name">{{ device.label }}</span>
              <el-tag v-if="device.online === '1'" type="success" size="mini" style="margin-left: 6px;">在线</el-tag>
              <el-tag v-else type="danger" size="mini" style="margin-left: 6px;">离线</el-tag>
            </div>
            <span class="device-serial">{{ device.videoDeviceSerial }}</span>
          </div>
          <div class="video-card-body">
            <!-- 离线设备显示提示，不初始化播放器 -->
            <div v-if="device.online === '0' || !device.online" class="offline-placeholder">
              <i class="el-icon-warning-outline"></i>
              <span>设备不在线</span>
            </div>
            <!-- 在线设备初始化播放器 -->
            <div v-else :id="'multiPlayer-' + index" class="multi-ezui-player"></div>
          </div>
        </div>
        <!-- 填充空白卡片以保持九宫格布局 -->
        <div v-for="i in emptyCardsCount" :key="'empty-' + i" class="video-card empty-card">
          <div class="empty-content">
            <i class="el-icon-monitor"></i>
            <span>暂无视频</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDeviceList2,
  getLocationListGroupByDevice2,
  getDeviceListByExam,
  getAllExamList,
  getVideoToken,
  getVideoTokenFromRemoteServer,
} from "@/http/api/common";
import EZUIKit from "ezuikit-js";

// import locationData from "./locationData.json";
// console.log("locationData:", locationData);

export default {
  name: "LocationTrace",
  data: function () {
    return {
      examId: [],
      examOptions: [],
      speedValue: 3000,
      loop: false,
      showSetting: false,
      defaultProps: {
        children: "deviceList",
        label: "deviceName",
      },
      pathNavigators: [],
      type: "2",
      options: [
        {
          value: "1",
          label: "静态轨迹",
        },
        {
          value: "2",
          label: "动态汽车导航器轨迹",
        },
        {
          value: "3",
          label: "动态箭头导航器轨迹",
        },
      ],
      btnDisabled: false,
      ruleForm: {
        date: (() => {
          const today = new Date();
          const start = new Date(today);
          start.setHours(0, 0, 0, 0); // 设置为当天 00:00:00

          const end = new Date(today);
          end.setHours(23, 59, 59, 999); // 设置为当天 23:59:59

          return [start, end];
        })(),
        // date: [],
        // devices: ["70757100031", "70757100032"],
        devices: [],
      },
      devicesOptions: [],
      devicesTreeData: [],
      rules: {
        devices: [{ required: true, message: "请选择设备", trigger: "change" }],
        date: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
      },
      // pointsList: [
      //   {
      //     id: "2882880454107",
      //     examDistrictName: "",
      //     examPlaceType: "考点",
      //     examPlaceName:
      //       "丰台区-首都医科大学花乡校区（原首都医科大学附属卫生学校）",
      //     address: "丰台区花乡张家路口107号",
      //     longitude: "116.323881",
      //     latitude: "39.843389",
      //     examDistrictNum: null,
      //     examPlaceNum: null,
      //     examinationRoomNum: 30,
      //     technicalSupportName: null,
      //     technicalSupportTel: null,
      //     meetingId: "9083493798",
      //     examPlaceHaveCommandScreen: null,
      //     examRoomHaveMonitoringScreen: null,
      //   },
      //   {
      //     id: "2882880454101",
      //     examDistrictName: "北京市",
      //     examPlaceType: "市指挥调度中心",
      //     examPlaceName: "北京市人事考评办公室",
      //     address: "莲花苑3号楼",
      //     longitude: "116.304467",
      //     latitude: "39.896124",
      //     examDistrictNum: 2,
      //     examPlaceNum: 2,
      //     examinationRoomNum: 60,
      //     technicalSupportName: "魏然其上",
      //     technicalSupportTel: "13661144302",
      //     meetingId: "9083390904",
      //     examPlaceHaveCommandScreen: null,
      //     examRoomHaveMonitoringScreen: null,
      //   },
      //   {
      //     id: "ae44132eadac40ebb7082345b069f2e8",
      //     examDistrictName: "朝阳区",
      //     examPlaceType: "考点",
      //     examPlaceName: "北京财贸职业学校（朝阳校校区）",
      //     address: "朝阳区水锥子东路15号",
      //     longitude: "116.47413",
      //     latitude: "39.990922",
      //     examDistrictNum: null,
      //     examPlaceNum: 0,
      //     examinationRoomNum: 30,
      //     technicalSupportName: null,
      //     technicalSupportTel: null,
      //     meetingId: "9083339367",
      //     examPlaceHaveCommandScreen: null,
      //     examRoomHaveMonitoringScreen: null,
      //   },
      //   {
      //     id: "57a9d31513674045b74447cfe9ca7cc9",
      //     examDistrictName: "朝阳区",
      //     examPlaceType: "区指挥调度中心",
      //     examPlaceName: "朝阳区指挥调度中心",
      //     address: "北京市将台路5号院",
      //     longitude: "116.498909",
      //     latitude: "39.972603",
      //     examDistrictNum: null,
      //     examPlaceNum: 2,
      //     examinationRoomNum: 60,
      //     technicalSupportName: "赵清瑶",
      //     technicalSupportTel: null,
      //     meetingId: "9083475743",
      //     examPlaceHaveCommandScreen: null,
      //     examRoomHaveMonitoringScreen: null,
      //   },
      // ], // 考点列表
      pathSimplifierIns: null,
      pathSimplifier: null,
      pathList: [],
      colorList: [
        "#3366cc",
        "#dc3912",
        "#ff9900",
        "#109618",
        "#990099",
        "#0099c6",
        "#dd4477",
        "#66aa00",
        "#b82e2e",
        "#316395",
        "#994499",
        "#22aa99",
        "#aaaa11",
        "#6633cc",
        "#e67300",
        "#8b0707",
        "#651067",
        "#329262",
        "#5574a6",
        "#3b3eac",
      ],
      checkAll: false,
      // checkedCities: [],
      isIndeterminate: false,
      // 弹框相关
      dialogVisible: false,
      dialogData: {
        examDistrictName: "东城区",
        vehicleNumber: "东城区-05",
        deviceIMEI: "",
        videoDeviceSerial: "",
        examPlaceName: "北京市前门外国语学校",
        locationTime: "2025-12-07 07:19:03",
      },
      videoEnlarged: false,
      videoPlayer: null,
      playbackStartTime: "",
      playbackEndTime: "",
      deviceInfo: {
        deviceSerial: "BG9380217",
        channelNo: 1,
      },
      videoToken: "",
      multiVideoDialogVisible: false,
      selectedVideoDevices: [],
      multiVideoPlayers: [],
    };
  },

  computed: {
    emptyCardsCount() {
      const count = this.selectedVideoDevices.length;
      if (count === 0) return 9;
      if (count <= 9) return 9 - count;
      // 如果超过9个，则按3的倍数补齐
      return (3 - (count % 3)) % 3;
    },
  },

  mounted() {
    this.mapInit();

    getAllExamList().then((res) => {
      if (res.data && res.data.length > 0) {
        this.examOptions = res.data;
      } else {
        this.examOptions = [];
      }
    });

    let arr = [];
    if (this.$route.query.examId) {
      this.examId = [this.$route.query.examId];
      arr.push(this.$route.query.examId);
    }

    this.getDeviceList(arr);

    // 页面初始化时获取视频Token
    this.fetchVideoToken();
  },

  // 使用keep-alive缓存，不需要销毁逻辑
  // beforeDestroy() {
  //   // 页面销毁前销毁视频播放器
  //   this.destroyVideoPlayer();
  //   this.destroyMultiVideoPlayers();
  // },

  // keep-alive页面激活时调用
  activated() {
    // 恢复地图交互
    if (this.MAP) {
      this.MAP.setDraggable(true);
      this.MAP.setScrollWheelZoom(true);
      this.MAP.setDoubleClickZoom(true);
      this.MAP.setKeyboardEnabled(true);
      // 调整地图大小
      this.MAP.checkResize();
    }
  },

  // keep-alive页面停用时调用
  deactivated() {
    // 暂停地图交互
    if (this.MAP) {
      this.MAP.setDraggable(false);
      this.MAP.setScrollWheelZoom(false);
      this.MAP.setDoubleClickZoom(false);
      this.MAP.setKeyboardEnabled(false);
    }
  },

  methods: {
    changeExam(v) {
      console.log("changeExam v:", v);
      let arr = [];
      if (v) {
        arr = v;
      } else {
        this.examOptions.forEach((item) => {
          arr.push(item.id);
        });
      }
      this.pathList = [];
      console.log("arr: ", arr);
      this.getDeviceList(arr);
    },
    getDeviceList(list) {
      const d = {
        examIdList: list,
      };
      getDeviceListByExam(d).then((res) => {
        console.log("res11:", res);
        if (res.code === 200 && res.data?.length > 0) {
          let arr = [];
          res.data.forEach((item) => {
            item["deviceName"] = item.deptName.split("(")[0];
            if (item.deviceList?.length > 0) {
              item.deviceList.forEach((item2) => {
                arr.push(item2);
              });
            }
          });
          this.devicesOptions = arr.map((item) => {
            return {
              value: item.deviceIMEI,
              label: item.deviceName,
              deptName: item.deptName,
              videoDeviceSerial: item.videoDeviceSerial,
              videoCameraName: item.videoCameraName,
              online: item.online || "0",  // 在线状态，0=离线 1=在线
            };
          });

          this.devicesTreeData = [
            {
              id: "1",
              deviceName: "北京市",
              deviceList: res.data,
            },
          ];

          // 数据更新后展开所有节点
          this.$nextTick(() => {
            // this.$refs.tree.expandAll(true);

            this.$refs.tree.updateExpandedKeys(["1", "2"]);
          });

          console.log("this.devicesTreeData:", this.devicesTreeData);
        } else {
          this.$message({
            message: "获取设备列表失败！",
            type: "warning",
          });
        }
      });
    },
    async fetchVideoToken() {
      try {
        const res = await getVideoToken();
        console.log("fetchVideoToken res:", res);
        if (res.code === 200) {
          let token = res.data;

          // 验证Token是否过期（await 确保验证+刷新完成后再赋值）
          try {
            const checkRes = await fetch('https://open.ys7.com/api/lapp/device/list?accessToken=' + token, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
            });
            const data = await checkRes.json();
            console.log("Token验证结果:", data);

            if (data.code === '10002') {
              // Token过期，从远端服务器重新获取
              console.warn("Token已过期，正在重新获取...");
              const refreshRes = await getVideoTokenFromRemoteServer();
              console.log("重新获取Token结果:", refreshRes);
              if (refreshRes.code === 200) {
                token = refreshRes.data || refreshRes.msg;
                console.log("Token刷新成功:", token);
              } else {
                console.error("Token刷新失败:", refreshRes);
                this.$message.error("视频Token获取失败，请刷新页面重试");
                return;
              }
            } else {
              console.log("Token验证通过");
              // 利用萤石云设备列表接口返回的 status 字段同步更新设备在线状态
              // status: 1=在线, 0=离线（数字类型）
              if (data.code === '200' && Array.isArray(data.data) && data.data.length > 0) {
                // 构建 deviceSerial -> status 的映射表
                const statusMap = {};
                data.data.forEach(d => {
                  statusMap[d.deviceSerial] = d.status; // 1=在线, 0=离线
                });
                console.log("萤石云设备在线状态:", statusMap);
                // 更新 devicesOptions 中每个设备的 online 字段
                if (this.devicesOptions && this.devicesOptions.length > 0) {
                  this.devicesOptions = this.devicesOptions.map(opt => {
                    if (opt.videoDeviceSerial && statusMap.hasOwnProperty(opt.videoDeviceSerial)) {
                      const onlineStr = statusMap[opt.videoDeviceSerial] === 1 ? '1' : '0';
                      console.log(`设备 ${opt.label}(${opt.videoDeviceSerial}) 在线状态更新: ${onlineStr}`);
                      return { ...opt, online: onlineStr };
                    }
                    return opt;
                  });
                }
              }
            }
          } catch (e) {
            console.error("Token验证请求异常:", e);
          }

          this.videoToken = token;
          console.log("视频Token就绪:", this.videoToken);
        } else {
          console.error("获取视频Token失败：", res.msg);
          this.$message.error("获取视频Token失败：" + (res.msg || "未知错误"));
        }
      } catch (error) {
        console.error("获取视频Token异常:", error);
        this.$message.error("获取视频Token异常，请检查网络");
      }
    },
    changeSpeed(v) {
      console.log("v:", v);

      if (!this.pathNavigators || this.pathNavigators.length === 0) {
        console.warn("没有可用的巡航器");
        return;
      }

      this.pathNavigators.forEach((navigator) => {
        if (navigator && navigator.setSpeed) {
          navigator.setSpeed(v);
          console.log(`已更新巡航器速度为 ${v} km/h`);
        }
      });

      this.speedValue = v; // 更新 UI 显示
    },
    goToBack() {
      this.$router.go(-1);
    },
    handleCheckAllChange(val) {
      // this.ruleForm.devices = val
      //   ? this.devicesOptions.map((item) => {
      //     return item.value;
      //   })
      //   : [];
      console.log("val:", val);
      if (val) {
        this.$refs.tree.setCheckedNodes(this.devicesTreeData, false);
      } else {
        this.$refs.tree.setCheckedNodes(this.devicesTreeData, true);
      }

      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.devicesOptions.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.devicesOptions.length;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert("submit!");
          console.log(this.ruleForm);

          console.log("this.$refs.tree.getCheckedNodes():");
          console.log(this.$refs.tree.getCheckedNodes());

          if (this.$refs.tree.getCheckedNodes().length === 0) {
            this.$message({
              message: "请选择设备！",
              type: "warning",
            });
            return false;
          }

          this.btnDisabled = true;

          let imeiList = [];
          this.$refs.tree.getCheckedNodes().forEach((v) => {
            if (v.deviceIMEI) {
              imeiList.push(v.deviceIMEI);
            }
          });
          this.ruleForm.devices = imeiList;
          const d = {
            // accountList: this.ruleForm.devices,
            // imeiList: this.ruleForm.devices,
            imeiList: imeiList,
            locationStartDate: this.ruleForm.date[0],
            locationEndDate: this.ruleForm.date[1],
          };
          getLocationListGroupByDevice2(d).then((res) => {
            this.btnDisabled = false;
            let locationDataList = [];
            if (res.code === 200 && res.data?.length > 0) {
              locationDataList = res.data;
            } else {
              this.$message({
                message: "获取轨迹数据失败！",
                type: "warning",
              });
            }

            // mock data
            // console.log("locationData:");
            // console.log(locationData);
            // locationDataList = locationData.data;

            console.log("locationDataList11:", locationDataList);

            // 处理数据
            const { devices, date } = this.ruleForm;
            console.log("devices:", devices, "date:", date);

            let arr1 = [];
            let delay = 0;

            devices.forEach((item) => {
              let obj = locationDataList.find(
                (item2) => item2.deviceIMEI === item
              );
              console.log("obj:", obj);
              if (obj && obj.dataList?.length > 0) {
                const deviceOption = this.devicesOptions.find(
                  (item2) => item2.value === item
                );
                obj["name"] = deviceOption.label;
                obj["videoDeviceSerial"] = deviceOption.videoDeviceSerial;
                obj["videoCameraName"] = deviceOption.videoCameraName;
                obj["points"] = [];
                obj.dataList.forEach((item2) => {
                  obj["points"].push({
                    name: item2.locationTime,
                    lnglat: [item2.sparkLongtitude, item2.sparkLatitude],
                    videoCameraName: deviceOption.videoCameraName,
                    videoDeviceSerial: deviceOption.videoDeviceSerial,
                  });
                });

                arr1.push(obj);
              } else {
                setTimeout(() => {
                  this.$message({
                    message:
                      this.devicesOptions.find((item2) => item2.value === item)
                        .label + " 无轨迹数据！",
                    type: "warning",
                  });
                }, delay);
                delay += 500;
              }
            });

            console.log("arr1:", arr1);

            this.pathList = arr1;

            this.updatePathSimplifier();
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 地图渲染
    mapInit() {
      let self = this;
      var options = {
        subdistrict: 0,
        extensions: "all",
        level: "province",
      };
      var district = new AMap.DistrictSearch(options);
      //查询北京市区域
      district.search("北京市", function (status, result) {
        var bounds = result.districtList[0]["boundaries"];
        var mask = [];
        for (var i = 0; i < bounds.length; i++) {
          mask.push([bounds[i]]);
        }
        //实例化地图
        var map = new AMap.Map("mapContainer", {
          resizeEnable: true,
          zoom: 10, // 北京市
          center: [116.406265, 39.903324], // 北京市
          // zoom: 11, // 朝阳区
          // center: [116.540051,39.941443], // 朝阳区
        });
        //添加描边
        for (var i = 0; i < bounds.length; i++) {
          new AMap.Polyline({
            path: bounds[i],
            // strokeColor:'#11f95a',
            strokeColor: "red",
            strokeWeight: 5,
            map: map,
          });
        }

        // 添加轨迹
        AMapUI.load(
          ["ui/misc/PathSimplifier", "lib/$"],
          function (PathSimplifier, $) {
            if (!PathSimplifier.supportCanvas) {
              alert("当前环境不支持 Canvas！");
              return;
            }

            self.pathSimplifier = PathSimplifier;

            self.pathSimplifierIns = new PathSimplifier({
              zIndex: 100,
              map: map, //所属的地图实例

              getPath: function (pathData, pathIndex) {
                var points = pathData.points,
                  lnglatList = [];

                for (var i = 0, len = points.length; i < len; i++) {
                  lnglatList.push(points[i].lnglat);
                }

                return lnglatList;
              },
              getHoverTitle: function (pathData, pathIndex, pointIndex) {
                if (pointIndex >= 0) {
                  //point
                  return (
                    pathData.name + "，" + pathData.points[pointIndex].name
                  );
                }

                return pathData.name + "，点数量 " + pathData.points.length;
              },

              renderOptions: {
                renderAllPointsIfNumberBelow: 100,
                pathLineStyle: {
                  dirArrowStyle: true,
                },
                getPathStyle: function (pathItem, zoom) {
                  console.log("pathItem:", pathItem);
                  console.log("pathItem.pathIndex:", pathItem.pathIndex);
                  const color = self.colorList[pathItem.pathIndex],
                    lineWidth = Math.round(3 * Math.pow(1.1, zoom - 3));

                  return {
                    pathLineStyle: {
                      strokeStyle: color,
                      lineWidth: lineWidth,
                    },
                    pathLineSelectedStyle: {
                      lineWidth: lineWidth + 2,
                      strokeStyle: color,
                    },
                    pathNavigatorStyle: {
                      fillStyle: color,
                    },
                    pathLineHoverStyle: {
                      strokeStyle: color,
                      lineWidth: lineWidth + 2,
                    },
                  };
                },
              },
            });

            console.log("pathSimplifierIns", self.pathSimplifierIns);

            self.pathSimplifierIns.on("pointClick", function (e, info) {
              console.log("e: ", e);
              console.log("info: ", info);
              console.log(
                "Click: " + info.pathData.points[info.pointIndex].name
              );

              // 显示轨迹信息弹框
              self.dialogVisible = true;

              // 更新弹框数据
              const deviceName = info.pathData.deviceName;
              const name = info.pathData.name;

              // 从deviceName中提取考区、车辆编号和考点名称
              // deviceName格式："东城-04 [北京市第二十四中学]"
              // name格式："东城-04"
              const districtMatch = name.match(/^(\S+?)-\d+/);
              const examDistrictName = name.split('-')[0];
              const vehicleNumber = name;
              const examPlaceName = name.split('-')[1];
              // // 提取考点名称
              // const placeMatch = name.match(/【(.*?)】/);
              // const examPlaceName = placeMatch ? placeMatch[1] : "";

              self.dialogData = {
                examDistrictName: examDistrictName,
                vehicleNumber: vehicleNumber,
                deviceIMEI: info.pathData.deviceIMEI,
                examPlaceName: examPlaceName,
                videoDeviceSerial: info.pathData.videoDeviceSerial,
                locationTime: info.pathData.points[info.pointIndex].name,
              };

              const pointTimeStr = info.pathData.points[info.pointIndex].name; // yyyy-MM-dd HH:mm:ss
              const pointDate = new Date(pointTimeStr.replace(/-/g, "/"));

              const startDate = pointDate;
              const endDate = new Date(pointDate);
              endDate.setHours(23, 59, 0, 0);

              const formatToEZ = (date) => {
                const y = date.getFullYear();
                const m = String(date.getMonth() + 1).padStart(2, "0");
                const d = String(date.getDate()).padStart(2, "0");
                const hh = String(date.getHours()).padStart(2, "0");
                const mm = String(date.getMinutes()).padStart(2, "0");
                const ss = String(date.getSeconds()).padStart(2, "0");
                return `${y}${m}${d}${hh}${mm}${ss}`;
              };

              self.playbackStartTime = formatToEZ(startDate);
              self.playbackEndTime = formatToEZ(endDate);

              // 延迟初始化视频，确保DOM已渲染
              self.$nextTick(() => {
                self.changePlaybackTime();
              });
            });
          }
        );
      });
    },
    updatePathSimplifier() {
      if (this.pathNavigators.length > 0) {
        this.pathNavigators.forEach((navigator) => {
          if (navigator && navigator.stop) {
            navigator.stop();
          }
        });
        this.pathNavigators = [];
      }

      // 重新设置数据
      this.pathSimplifierIns.setData(this.pathList);

      // 默认选择第一条路径
      // this.pathSimplifierIns.setSelectedPathIndex(0);
      let self = this;
      console.log(self.pathSimplifier);
      console.log(1111);
      console.log(this.pathList);

      if (this.pathList.length > 0 && this.type === "2") {
        this.pathList.forEach(function (item, index) {
          let navg1 = self.pathSimplifierIns.createPathNavigator(index, {
            loop: self.loop, //循环播放
            speed: self.speedValue, //巡航速度，单位千米/小时
            pathNavigatorStyle: {
              pathLinePassedStyle: null,
              width: 16,
              height: 32,
              content: self.pathSimplifier.Render.Canvas.getImageContent(
                "/imgs/car.png",
                onload,
                onerror
              ),
              strokeStyle: null,
              fillStyle: null,
            },
          });

          // navg1.start();
          if (navg1 && navg1.start) {
            navg1.start();
            self.pathNavigators.push(navg1); // 保存到数组中
          }
        });
      }

      if (this.pathList.length > 0 && this.type === "3") {
        this.pathList.forEach(function (item, index) {
          let navg1 = self.pathSimplifierIns.createPathNavigator(index, {
            loop: self.loop, //循环播放
            speed: self.speedValue, //巡航速度，单位千米/小时
            // pathNavigatorStyle: {
            //   // pathLinePassedStyle: null,
            //   // width: 16,
            //   // height: 32,
            //   // content: self.pathSimplifier.Render.Canvas.getImageContent(
            //   //   "/imgs/car.png",
            //   //   onload,
            //   //   onerror
            //   // ),
            //   // strokeStyle: null,
            //   // fillStyle: null,
            // },
          });

          // navg1.start();
          if (navg1 && navg1.start) {
            navg1.start();
            self.pathNavigators.push(navg1); // 保存到数组中
          }
        });
      }
    },

    // 初始化视频播放器
    initVideoPlayer() {
      // 销毁已存在的播放器实例
      this.destroyVideoPlayer();

      if (!this.videoToken) {
        this.$message.warning("视频Token尚未获取，请稍后再试");
        // 尝试重新获取
        this.fetchVideoToken();
        return;
      }

      // 构建完整的回放URL，包含开始时间和结束时间
      // 使用云端录像协议 (.cloud.rec)，读取萤石云云端存储录像，设备不在线时也可回放
      // 使用 dialogData 中的 videoDeviceSerial
      const playbackUrl = `ezopen://open.ys7.com/${this.dialogData.videoDeviceSerial}/${this.deviceInfo.channelNo}.cloud.rec?begin=${this.playbackStartTime}&end=${this.playbackEndTime}`;

      // 使用导入的EZUIKit初始化播放器
      this.videoPlayer = new EZUIKit.EZUIKitPlayer({
        id: "ezuiPlayer",
        accessToken: this.videoToken,
        // accessToken: "at.cig0cfmn49cvvnp3btc8gubs6yodwu7b-9kgo6uydm7-14e769m-n8lr4irq4",
        url: playbackUrl,

        width: "100%",
        height: "100%",
        autoplay: true,
        audio: 0,
        openSoundCallBack: function () { },
        closeSoundCallBack: function () { },
        // EZUIKit回放模板配置
        template: "pcRec", // 使用回放模板
        plugin: ["fullScreen"], // 启用全屏插件
      });

      console.log("视频播放器初始化完成");
    },

    // 切换回放时间
    changePlaybackTime() {
      // 确保DOM已更新
      this.$nextTick(() => {
        // 如果播放器未初始化，则初始化
        if (!this.videoPlayer) {
          this.initVideoPlayer();
        } else {
          // 如果播放器已初始化，则切换播放时间（云端录像URL）
          const playbackUrl = `ezopen://open.ys7.com/${this.dialogData.videoDeviceSerial}/${this.deviceInfo.channelNo}.cloud.rec?begin=${this.playbackStartTime}&end=${this.playbackEndTime}`;
          this.videoPlayer.changePlayUrl({ url: playbackUrl });
          console.log("切换云端回放时间:", playbackUrl);

          // 切换URL后尝试恢复播放，确保视频自动开始播放
          this.$nextTick(() => {
            if (this.videoPlayer && this.videoPlayer.resume) {
              this.videoPlayer.resume();
              console.log("回放视频已开始播放");
            }
          });
        }
      });
    },

    // 切换视频大小
    toggleVideoSize() {
      this.videoEnlarged = !this.videoEnlarged;

      // 延迟调整播放器大小，确保DOM已更新
      this.$nextTick(() => {
        if (this.videoPlayer && this.videoPlayer.resize) {
          this.videoPlayer.resize();
        }
      });
    },

    // 暂停视频
    pauseVideo() {
      if (this.videoPlayer && this.videoPlayer.pause) {
        this.videoPlayer.pause();
        console.log("视频已暂停");
      }
    },

    // 恢复视频
    resumeVideo() {
      if (this.videoPlayer && this.videoPlayer.resume) {
        this.videoPlayer.resume();
        console.log("视频已恢复播放");
      }
    },

    // 销毁视频播放器
    destroyVideoPlayer() {
      if (this.videoPlayer) {
        this.videoPlayer.stop();
        this.videoPlayer.destroy();
        this.videoPlayer = null;
        console.log("视频播放器已销毁");
      }
    },

    // 处理开始时间变化
    handleStartTimeChange(val) {
      if (val) {
        // val 格式为 yyyyMMddHHmmss
        const year = val.substring(0, 4);
        const month = val.substring(4, 6);
        const day = val.substring(6, 8);
        this.playbackEndTime = `${year}${month}${day}235900`;
        console.log("自动更新结束时间:", this.playbackEndTime);
      }
    },

    // 获取萤石云设备摄像头列表
    async fetchYingshiyunDeviceList() {
      // if (!this.videoToken) {
      //   await this.fetchVideoToken();
      // }

      try {

        const response = await fetch('https://open.ys7.com/api/lapp/device/list?accessToken=' + this.videoToken, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });
        const data = await response.json();
        console.log("萤石云设备摄像头列表:", data);

        if (data.code === '200' && Array.isArray(data.data)) {
          // 构建 deviceSerial -> status 映射表 (status: 1=在线, 0=离线)
          const statusMap = {};
          data.data.forEach(item => {
            statusMap[item.deviceSerial] = item.status;
          });
          return statusMap;
        } else {
          console.error("获取设备列表失败:", data.msg);
          return {};
        }
      } catch (error) {
        console.error("获取萤石云设备列表异常:", error);
        return {};
      }
    },

    // 打开多路视频弹框
    async openMultiVideoDialog() {
      const checkedNodes = this.$refs.tree.getCheckedNodes();
      let selectedDevices = checkedNodes
        .filter((node) => node.deviceIMEI)
        .map((node) => {
          return this.devicesOptions.find((opt) => opt.value === node.deviceIMEI);
        })
        .filter((opt) => opt && opt.videoDeviceSerial);

      if (selectedDevices.length === 0) {
        this.$message.warning("请先选择带有视频序列号的设备");
        return;
      }

      // 显示加载提示
      const loading = this.$loading({
        lock: true,
        text: '正在获取设备状态...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {
        // 调用萤石云API获取设备状态
        const statusMap = await this.fetchYingshiyunDeviceList();

        // 更新选中设备的状态
        selectedDevices = selectedDevices.map(device => {
          if (device.videoDeviceSerial && statusMap.hasOwnProperty(device.videoDeviceSerial)) {
            const onlineStatus = statusMap[device.videoDeviceSerial] === 1 ? '1' : '0';
            console.log(`设备 ${device.label}(${device.videoDeviceSerial}) 状态更新: ${onlineStatus === '1' ? '在线' : '离线'}`);
            return { ...device, online: onlineStatus };
          }
          return device;
        });

        // 更新devicesOptions中的设备状态
        selectedDevices.forEach(updatedDevice => {
          const optIndex = this.devicesOptions.findIndex(opt => opt.value === updatedDevice.value);
          if (optIndex !== -1) {
            this.devicesOptions[optIndex].online = updatedDevice.online;
          }
        });

        // 设置选中的视频设备
        this.selectedVideoDevices = selectedDevices;

        // 显示设备状态统计
        const onlineCount = selectedDevices.filter(device => device.online === '1').length;
        const offlineCount = selectedDevices.length - onlineCount;

        console.log('更新后的selectedVideoDevices:', this.selectedVideoDevices);
        console.log(`在线设备: ${onlineCount}, 离线设备: ${offlineCount}`);

        if (offlineCount > 0) {
          this.$message.warning(`${offlineCount} 个设备离线，将不初始化播放器`);
        }
        if (onlineCount > 0) {
          this.$message.success(`${onlineCount} 个设备在线，正在初始化播放器`);
        }

        loading.close();

        this.multiVideoDialogVisible = true;

        this.$nextTick(() => {
          this.initMultiVideoPlayers();
        });

      } catch (error) {
        console.error("获取设备状态失败:", error);
        this.$message.error("获取设备状态失败，请稍后重试");
        loading.close();
      }
    },

    // 初始化多路视频播放器（实时视频）
    initMultiVideoPlayers() {
      this.destroyMultiVideoPlayers();

      if (!this.videoToken) {
        this.$message.warning("视频Token尚未获取，请稍后再试");
        this.fetchVideoToken();
        return;
      }

      this.selectedVideoDevices.forEach((device, index) => {
        // 跳过离线设备，不初始化播放器
        if (device.online === "0" || !device.online) {
          console.log(`设备 ${device.label} 离线，跳过播放器初始化`);
          return;
        }

        // 构建实时视频URL
        const liveUrl = `ezopen://open.ys7.com/${device.videoDeviceSerial}/1.hd.live`;

        try {
          const player = new EZUIKit.EZUIKitPlayer({
            id: "multiPlayer-" + index,
            accessToken: this.videoToken,
            url: liveUrl,
            width: "100%",
            height: "100%",
            autoplay: true,
            audio: 0,
            template: "standard", // 使用标准模板
            plugin: ["fullScreen"], // 启用全屏插件
          });
          this.multiVideoPlayers.push(player);
        } catch (error) {
          console.error(`初始化播放器 ${device.label} 失败:`, error);
        }
      });
    },

    // 销毁多路视频播放器
    destroyMultiVideoPlayers() {
      if (this.multiVideoPlayers.length > 0) {
        this.multiVideoPlayers.forEach((player) => {
          if (player) {
            if (player.stop) player.stop();
            if (player.destroy) player.destroy();
          }
        });
        this.multiVideoPlayers = [];
      }
    },

    // 处理多路视频弹框关闭
    handleMultiVideoClose() {
      this.destroyMultiVideoPlayers();
    },
  },

  // 监听弹框关闭事件，销毁视频播放器
  watch: {
    dialogVisible(newVal) {
      if (!newVal) {
        this.destroyVideoPlayer();
        this.videoEnlarged = false;
      }
    },
  },
};
</script>

<style lang="scss">
.app-header {
  height: 60px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 1000;
  padding: 0 24px;

  .header-content {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo-section {
      display: flex;
      align-items: center;
      cursor: pointer;
      gap: 12px;

      .back-icon {
        font-size: 20px;
        color: #606266;

        &:hover {
          color: #409eff;
        }
      }

      .logo-img {
        width: 40px;
        height: 40px;
        border-radius: 4px;
      }

      .title {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
        letter-spacing: 0.5px;
      }
    }

    .setting-icon {
      font-size: 22px;
      color: #909399;
      cursor: pointer;

      &:hover {
        color: #409eff;
      }
    }
  }
}

.main-content {
  height: calc(100vh - 60px);
  display: flex;
  overflow: hidden;

  .sidebar {
    width: 380px;
    background: #fff;
    border-right: 1px solid #ebeef5;
    display: flex;
    flex-direction: column;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.02);

    .sidebar-scroll {
      flex: 1;
      overflow-y: auto;
      padding: 20px;

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-thumb {
        background: #e4e7ed;
        border-radius: 3px;
      }
    }

    .sidebar-form {
      .el-form-item {
        margin-bottom: 18px;

        .el-form-item__label {
          font-weight: 600;
          color: #606266;
          padding-bottom: 4px;
        }
      }

      .device-tree-item {
        .tree-container {
          border: 1px solid #dcdfe6;
          border-radius: 4px;
          max-height: 400px;
          overflow-y: auto;
          padding: 8px;

          .el-tree {
            background: transparent;
          }
        }
      }

      .action-buttons {
        margin-top: 24px;
        display: flex;
        flex-direction: column;
        gap: 12px;

        .action-btn {
          width: 100%;
          height: 40px;
          font-size: 14px;
          font-weight: 500;
          margin: 0 !important;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          border-radius: 4px;
          transition: all 0.2s;




          &:active {
            opacity: 0.8;
          }
        }
      }
    }

    .path-legend {
      margin-top: 30px;
      padding-top: 20px;
      border-top: 1px dashed #ebeef5;

      .legend-title {
        font-size: 14px;
        font-weight: 600;
        color: #909399;
        margin-bottom: 12px;
      }

      .legend-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 12px;
        background: #f8f9fb;
        border-radius: 4px;
        margin-bottom: 8px;

        .legend-name {
          font-size: 13px;
          color: #606266;
        }

        .legend-color {
          width: 40px;
          height: 12px;
          border-radius: 6px;
        }
      }
    }
  }

  .map-area {
    flex: 1;
    position: relative;

    #mapContainer {
      width: 100%;
      height: 100%;
    }
  }
}

/* 轨迹信息弹框样式 */
.trace-dialog {
  .el-dialog__title {
    font-weight: bold;
  }

  .el-dialog {
    margin-top: 20px !important;
  }
}

.trace-info {
  .info-item {
    margin-bottom: 16px;
    display: flex;
    align-items: center;

    .info-label {
      font-weight: bold;
      width: 80px;
      color: #606266;
    }

    .info-value {
      color: #303133;
    }
  }

  .video-section {
    margin-top: 24px;

    .section-title {
      font-weight: bold;
      color: #606266;
      margin-bottom: 12px;
    }

    .search-form {
      display: flex;
      align-items: center;

      .el-form-item {
        margin-bottom: 0;
        margin-right: 20px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .video-container {
      width: 100%;
      height: 300px;
      background-color: #000;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s ease;
      overflow: hidden;

      &.video-enlarged {
        height: 500px;
      }

      .ezui-player {
        width: 100%;
        height: 100%;
      }
    }

    .video-controls {
      margin-top: 12px;
      display: flex;
      gap: 12px;
      justify-content: center;
    }
  }
}

/* 隐藏日期选择器的“此刻”按钮 */
.no-now-button {
  .el-picker-panel__footer {
    .el-button--text {
      display: none;
    }
  }
}

/* 轨迹详情弹框样式 */
.trace-dialog {
  background-image: url('../../assets/img/bg001.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.trace-dialog .el-dialog__body {
  padding: 20px;
}

.trace-info {
  .basic-info {
    background-color: rgba(255, 255, 255, 0.9);
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 20px;
  }

  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 15px;
  }

  .info-row {
    display: flex;
    margin-bottom: 10px;
  }

  .info-item {
    flex: 1;
    display: flex;
    align-items: center;
    padding-right: 15px;
  }

  .info-label {
    font-weight: 600;
    width: 80px;
    color: #606266;
    margin-right: 10px;
  }

  .info-value {
    color: #303133;
    flex: 1;
  }

  .playback-search {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }

  .query-btn {
    margin-left: 10px;
    padding: 10px 20px;
    font-size: 16px;
  }

  .dialog-actions {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }

  .close-btn {
    width: 120px;
    height: 40px;
  }
}

/* 多路视频回放样式 */
.multi-video-dialog {
  background-color: #1a1c1e !important;

  .el-dialog__header {
    background-color: #25282b;
    padding: 15px 20px;
    border-bottom: 1px solid #333;

    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 1px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #909399;
      font-size: 20px;

      &:hover {
        color: #409eff;
      }
    }
  }

  .el-dialog__body {
    padding: 0 !important;
    background-color: #1a1c1e;
  }
}

.multi-video-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  grid-gap: 12px;
  padding: 12px;
  background-color: #1a1c1e;
  height: calc(100vh - 50px);
  box-sizing: border-box;

  .video-card {
    background: #25282b;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;
    border: 1px solid #333;
    transition: transform 0.2s ease, border-color 0.2s ease;

    &:hover {
      border-color: #409eff;
      transform: translateY(-2px);
    }

    .video-card-header {
      padding: 6px 12px;
      background: #2d3135;
      border-bottom: 1px solid #333;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 32px;
      box-sizing: border-box;

      .header-left {
        display: flex;
        align-items: center;
        gap: 8px;

        i {
          color: #409eff;
          font-size: 14px;
        }
      }

      .device-name {
        font-weight: 500;
        color: #e4e7ed;
        font-size: 13px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 300px;
      }

      .device-serial {
        color: #909399;
        font-size: 11px;
        font-family: monospace;
      }
    }

    .video-card-body {
      flex: 1;
      background: #000;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      .multi-ezui-player {
        width: 100%;
        height: 100%;
      }

      .offline-placeholder {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        color: #909399;

        i {
          font-size: 40px;
          color: #f56c6c;
          opacity: 0.7;
        }

        span {
          font-size: 14px;
          letter-spacing: 1px;
        }
      }
    }

    &.empty-card {
      border: 1px dashed #444;
      background: #1e2124;
      box-shadow: none;
      justify-content: center;
      align-items: center;

      &:hover {
        border-color: #555;
        transform: none;
      }

      .empty-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        color: #5c6066;

        i {
          font-size: 40px;
          opacity: 0.5;
        }

        span {
          font-size: 14px;
          letter-spacing: 1px;
        }
      }
    }
  }
}
</style>
